import * as config from './config'

export const clientId = '3'
export const clientSecret = '1219af06d9135d626558916673e16717ff57fc71'

let pusherConfig = {
  pusher: {
    broadcaster: 'pusher',
    key: '696ffb473ba2ecb66c14',
    cluster: 'us2',
    encrypted: true,
    authEndpoint: config.apiURL + '/broadcasting/auth'
  }
}
if (process.env.NODE_ENV === 'development') pusherConfig.pusher.key = '5779e01a3b13136f350f'
if (process.env.NODE_ENV === 'homolog') pusherConfig.pusher.key = 'e748d65ace8180b24590'
if (process.env.NODE_ENV === 'demo') pusherConfig.pusher.key = '18baae28e53eda3b3ed5'

export const lavarelEchoConfig = pusherConfig



// WEBPACK FOOTER //
// ./src/env.js